import React from 'react'
import {connect} from 'react-redux'
import {nextFrame, PreviousLink} from './shared'
import {CheckMarkCard} from 'js/studios/shared/flows'

@connect((state, props) => ({
  selected: state.projectCreationData[props.field],
}))
class ChooseCategoryFrame extends React.Component {

  select(name, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: this.props.field,
      value: name
    })
    nextFrame(e)
  }

  render(){
    return (
      <div className="frame-wrapper category fade-in">
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />{this.props.title}</h2>
            <p className="subheader-body">{this.props.description}</p>
            <div className="category-options cards-wrapper">
              {this.props.cards.map(card => (
                <CheckMarkCard
                  key={card.name}
                  name={card.name}
                  className="card-normal"
                  imgUrl={card.img}
                  label={card.label}
                  checked={false}
                  disabled={false}
                  toggleChecked={this.select.bind(this, card.name)}
                  />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const CATEGORY_TOP_CHOICES = [
  {
    name: "engagement",
    img: "//images.custommade.com/vSr8uw2gj9tPnuhP_KDr0c87ksc=/custommade-attachments/0a5e98d82ec504b_engagement.jpg",
    label: "engagement ring"
  },
  {
    name: "other",
    img: "//images.custommade.com/KAg42D8exNK1b7m9SMQHC8otPok=/custommade-attachments/7db3bf7636f46b7_category_select_other_jewelry.jpg",
    label: "other jewelry"
  },
]

export class ChooseCategoryTopFrame extends React.Component {
  render(){
    return (
      <ChooseCategoryFrame
        title="First, What Are We Making?"
        description="Seeking the perfect engagement ring, or another type of jewelry?"
        field="categoryTop"
        cards={CATEGORY_TOP_CHOICES}
      />
    )
  }
}

const CATEGORY_SECONDARY_CHOICES = [
  {
    name: "signet_ring",
    img: "//images.custommade.com/7cwukbl1N3vRF-ldDRobaEyk0VQ=/custommade-attachments/3e41ae589e08b6e_signet_ring.jpg",
    label: "signet ring"
  },
  {
    name: "mens_wedding_band",
    img: "//images.custommade.com/RwuEywGR45a1y-4pFpNBAkmhQf4=/custommade-attachments/4c17bc2135151d9_mens_wedding_band.jpg",
    label: "men's wedding band"
  },
  {
    name: "womens_wedding_band",
    img: "//images.custommade.com/LfYfyB_IWebF6dWG_6Ud3-qS5ko=/custommade-attachments/a3e26e0a4adf55d_womens_wedding_band.jpg",
    label: "women's wedding band"
  },
  {
    name: "cocktail_ring",
    img: "//images.custommade.com/OpjA3HB0L8TIjUov7EOg0MUwn7s=/custommade-attachments/f898dac645f4ba2_cocktail_ring.jpg",
    label: "cocktail / gemstone ring"
  },
  {
    name: "wedding_band_set",
    img: "//images.custommade.com/k4_o1D1odbpP8BABYcLjUGwYg8o=/custommade-attachments/9426b2025c1ac3a_wedding_band_set.jpg",
    label: "wedding band set"
  },
  {
    name: "class_ring",
    img: "//images.custommade.com/S05GeHcatt7V8ojRW-j94Xivawk=/custommade-attachments/2fc9a4824340c7b_class_ring.jpg",
    label: "class ring"
  },
  {
    name: "necklace",
    img: "//images.custommade.com/XODIyfaXumNlNlXtCiOrRIXip3k=/custommade-attachments/d5129004b790642_necklace.jpg",
    label: "necklace"
  },
  {
    name: "cufflinks",
    img: "//images.custommade.com/5pUpQ-u1r7FEJpVF-tEqwPKLtmA=/custommade-attachments/66208c34ce2a850_cufflinks.jpg",
    label: "cufflinks"
  },
  {
    name: "earrings",
    img: "//images.custommade.com/Izt4Tkdopd9cpLcKQfR0mbHlMcA=/custommade-attachments/07e67be8b435aa3_earrings.jpg",
    label: "earrings"
  },
  {
    name: "other_ring",
    img: "//images.custommade.com/aEUUgbMITzwS9CoMkFMd04Na5j8=/custommade-attachments/e35d027101219ed_other_ring.jpg",
    label: "other ring"
  },
  {
    name: "other",
    img: "//images.custommade.com/hZ8c3LQQg9QIfIQiwPAXCNFCQtE=/custommade-attachments/55e16e2d1c1450b_other.jpg",
    label: "other"
  }
]

export class ChooseCategorySecondaryFrame extends React.Component {
  render(){
    return (
      <ChooseCategoryFrame
        title="Choose A Type Of Jewelry"
        description="We offer many types of rings, in addition to other kinds of jewelry."
        field="categorySecondary"
        cards={CATEGORY_SECONDARY_CHOICES}
      />
    )
  }
}
